import { combineReducers } from "redux";
import athleteReducer from "./athleteReducers";
import authReducer from "./authReducers";
import fansReducers from "./fansReducers";
import requestedCitiesReducer from "./requestedCitiesReducer";
import requestedSportsReducer from "./requestedSportsReducer";
import sportReducer from "./sportReducer";
import userReducer from "./userReducer";
import confirmConsentReducer from "./confirmConsentReducer";
import newSchoolsReducer from "./newSchoolsReducer";
import newCollegeUniversitiesData from "./newCollegeUniversitiesReducer";
import shopReducer from "./shopReducer";
import tutorialsReducer from "./tutorialsReducer";
import notificationReducer from "./notificationReducer";
import seasonReducer from "./seasonReducer";
import trendingReducers from "./trendingReducers";
import resolutionCenterReducer from "./resolutionCenterReducer";

import blogReducer from "./blogReducer";
import ContractReducer from "./RequestSchoolContractsReducer";
import walletReducer from "./walletReducer";
import VerifyBadgesReducers from "./VerifyBadgesReducers";
import talkingBadgeReducer from "./talkingBadgeReducer";
import contestReducer from "./contestReducer";
import AvRatingReducer from "./AvRatingReducer";
import pizzaMoneyReducer from "./pizzaMoneyReducer";
import managerReducer from "./managerReducer";
import adsReducers from "./adsReducers";
import SportsCommunityBadgeReducer from "./SportsCommunityBadgeReducer";
import bulletinBoardReducer from "./bulletinBoardReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  fan: fansReducers,
  athlete: athleteReducer,
  sport: sportReducer,
  users: userReducer,
  requestedSports: requestedSportsReducer,
  requestedCities: requestedCitiesReducer,
  confirmConsent: confirmConsentReducer,
  schools: newSchoolsReducer,
  collegeAndUniversities: newCollegeUniversitiesData,
  shop: shopReducer,
  tutorial: tutorialsReducer,
  notification: notificationReducer,
  season: seasonReducer,
  trending: trendingReducers,
  blog: blogReducer,
  resolution: resolutionCenterReducer,
  contract: ContractReducer,
  wallet: walletReducer,
  verifyBadges: VerifyBadgesReducers,
  talkingBadges: talkingBadgeReducer,
  contest: contestReducer,
  officialData: AvRatingReducer,
  pizzaMoneyAthletes: pizzaMoneyReducer,
  manager: managerReducer,
  ads: adsReducers,
  sportsCommunityBadge: SportsCommunityBadgeReducer,
  bulletinBoard: bulletinBoardReducer,
});
export default rootReducer;
